<div class="container-generic">
  <app-menu [menuModuleEnum]='menuModuleEnum' [menuFunctionalityEnum]='menuFunctionalityEnum'></app-menu>

  <div class="container-body">
    <h1>Notificações de agravo preenchidas</h1>
    @if (isFirstLoading) {
      <app-loading-progress-bar></app-loading-progress-bar>
    }
    <div class="white-body">
      <div class="row filters">

        <div class="col-12 col-md-3">
          <mat-form-field appearance="outline">
            <mat-label>CPF ou CNS do paciente</mat-label>
            <input [(ngModel)]="cpfOrCns" #cpfField="ngModel" matInput type="text" (keyup)="onKeySearchCPF($event)"
              (keydown)="$event.stopImmediatePropagation()" [mask]="masks.cpfCns">
              @if (cpfField.invalid) {
                <mat-error>CPF Inválido</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-md-3">
            <mat-form-field appearance="outline">
              <mat-label>Número do episódio</mat-label>
              <input [(ngModel)]="episode" matInput type="text" (keyup)="onKeySearchEpisode($event)"
                (keydown)="$event.stopImmediatePropagation()">
              </mat-form-field>
            </div>
            <div class="col-12 col-md-3">
              <mat-form-field appearance="outline">
                <mat-label>Data de geração</mat-label>
                <input [(ngModel)]="generationDate" matInput type="text" (keyup)="onKeySearchGenerationDate($event)"
                  (keydown)="$event.stopImmediatePropagation()" [mask]="masks.date">
                </mat-form-field>
              </div>

            </div>
            @if (!isLoading && listGrievanceNotification != null && listGrievanceNotification.length > 0) {
              <div class="card-list">
                <div class="row">
                  @for (item of listGrievanceNotification; track item) {
                    <div class="col-12 col-sm-6 col-md-4">
                      <div class="card-item">
                        <div class="infos">
                          <span class="primary">{{item.grievanceNotificationName}}</span>
                          <span class="secundary">Nome do paciente: {{item.patientName}}</span>
                          <span class="secundary">Episódio: {{item.idEpisode}}</span>
                          <span class="secundary">Data de nascimento: {{item.patientBirthDatetime | date: 'dd/MM/yyyy'}}</span>
                          <span class="secundary">Enfermeiro responsável pela geração da notificação: {{item.userName}}</span>
                          <span class="secundary">Data: {{item.datetimeInclusion | date: 'dd/MM/yyyy'}}</span>
                        </div>
                        <div class="actions">
                          <a><mat-icon aria-hidden="false" aria-label="Editar" (click)="goGrievanceNotification(item)">visibility</mat-icon>
                        </a>
                        <a>@if (reprintLoading == false) {
                          <mat-icon matTooltip="Reimprimir Ficha"
                          (click)="reprintReport(item.idGuideGrievanceNotification)">grading</mat-icon>
                        }
                        @if (reprintLoading == true) {
                          <mat-spinner [diameter]="25" class="mat-spinner-btn"
                          ></mat-spinner>
                        }
                      </a>
                    </div>
                  </div>
                </div>
              }
            </div>
            <div class="row">
              <div class="col-12 col-sm-12 col-md-12">
                <mat-paginator #paginator [length]="fullListSize" [pageIndex]="pageIndex" [pageSize]="pageSize"
                  aria-label="Select page" (page)="changePage($event.pageIndex)" [hidePageSize]="true">
                </mat-paginator>
              </div>
            </div>
          </div>
        }
        @if (!isLoading && (!listGrievanceNotification || (listGrievanceNotification != undefined && listGrievanceNotification.length == 0))) {
          <app-empty-list></app-empty-list>
        }
        @if (isLoading) {
          <app-loading-list></app-loading-list>
        }
      </div>

    </div>
  </div>